import { render, staticRenderFns } from "./ownaccount.vue?vue&type=template&id=08d36c9e&scoped=true&"
import script from "./ownaccount.vue?vue&type=script&lang=js&"
export * from "./ownaccount.vue?vue&type=script&lang=js&"
import style0 from "./ownaccount.vue?vue&type=style&index=0&id=08d36c9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d36c9e",
  null
  
)

export default component.exports